
document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.section-kpi')

	if (section) {
	}
})